import { forwardRef } from 'react';
/**
 * forwardRef that works with generics
 */
export const genericForwardRef = forwardRef;
//# sourceMappingURL=genericForwardRef.js.map